import * as React from 'react';
import { AppSettings } from "../../AppSettings";
import AppHelper from "../../Helper/AppHelper";

import { mdmAccesses } from "../../Interface/Role";

import Box from '@mui/material/Box';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { Accordion, AccordionDetails, AccordionSummary, Icon, IconButton, Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { sideBarItems } from "../../Data/sideBarItems";
import dsvLogo from "../../images/dsv-logo.png";
import { Logout, PersonAdd } from '@mui/icons-material';
import DisplaySettingsIcon from "@mui/icons-material/DisplaySettings";
import Settings from "@mui/icons-material/Settings";
import { useNavigate } from "react-router-dom";
import ExpandMoreIcon from "@mui/material/Icon";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import StorageTwoToneIcon from '@mui/icons-material/StorageTwoTone';
import { User } from "../../Interface/IUser";
type Anchor = 'top' | 'left' | 'bottom' | 'right';


export default function SwipeableTemporaryDrawer() {
  const [mdmAccessesInfo, setmdmAccessesInfo] = React.useState<mdmAccesses[]>([]);
  const navigate = useNavigate();
  const useEffectCount = React.useRef(true);
  React.useEffect(() => {
    AppHelper.isUserLogin();
    if (useEffectCount.current) {
      useEffectCount.current = false;
      getUserMDMAccessDetails();
    }
  }, []);

  

  function getUserMDMAccessDetails() {

    let UserinfoData = JSON.parse(localStorage.getItem("user-info-lpa") || " "); 
    userInfo.userType = UserinfoData.userType;

    let userID = AppHelper.getUser().id;
    let apiUrl =
      AppSettings.API_URL + "User/GetUserMDMAccesses?id=" + userID;
    fetch(apiUrl, AppHelper.requestOptions("POST"))
      .then((response) => {
        console.log(response);
        //debugger;
        if (!response.ok) {
          //alert("testdata")
          if (response.status == 401) navigate("/SessionExpired");
          else
            throw new Error(
              `API Error, This is an HTTP error: The status is ${response.status}`
            );
        }
        return response.json();
      })
      .then((data) => {
        if (data != undefined) {
          let mdmAccesses: mdmAccesses[] = data || " ";
          localStorage.setItem('mdmAccessesdata', JSON.stringify(data));
          var MDMAccessdata = JSON.parse(localStorage.getItem("mdmAccessesdata") || " ");
          if (data.errors == "No record found.") {
            setmdmAccessesInfo([]);
          } else {
            setmdmAccessesInfo(MDMAccessdata);
            
          }
        }
      })
      .catch((err) => {
        if (err.message === "Failed to fetch") {
          navigate("/SessionExpired");
        } else {
          setmdmAccessesInfo([
            // { id: 1, name: "Tariffs", link: "/TariffData", description: "Tarrifs", roleCode: "0", isActive: true },
          ]);
        }
      })
      .finally(() => {
      });
  }

  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  const [userInfo, setUserInfo] = React.useState<User>({
    id: 0,
    username: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
    password: "",
    email: "",
    createdBy: "",
    isActive: true,
    isMDMActive: false,
    roleID: "",
    userType: "",
    token: "",
    passwordResetRequired: false,
    passwordResetAlertMessage: "",
    mdmAccesses: [],
  });
  const handleCloseMenu = (link: string) => {

    if (link === "Logout") {
      localStorage.removeItem("user-info-lpa");
      window.location.href = "/";
    } else {
      navigate(link);
    }
    var drawer = {
      top: false,
      left: false,
      bottom: false,
      right: false,
    };
    setState(drawer);
  };

  const toggleDrawer =
    (anchor: Anchor, open: boolean) =>
      (event: React.KeyboardEvent | React.MouseEvent) => {
        if (
          event &&
          event.type === 'keydown' &&
          ((event as React.KeyboardEvent).key === 'Tab' ||
            (event as React.KeyboardEvent).key === 'Shift')
        ) {
          return;
        }
        setState({ ...state, [anchor]: open });
      };
  const list = (anchor: Anchor) => (
    <Box
      sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 }}
      role="presentation"
    //onClick={toggleDrawer(anchor, false)}
    // onKeyDown={toggleDrawer(anchor, false)}
    >

      <List > 
        <a href="/">
          <img src={dsvLogo} className="dsv-logo" />
        </a>

        <Box
          sx={{
            p: 2,
            borderRadius: 2,
            bgcolor: 'background.default',
            display: 'grid',
            gridTemplateColumns: { md: '1fr 1fr' },
            gap: 2,
          }}
        >
          {' '}
        </Box>

        {/* <Divider />  */}
        <ListItem key='Home' onClick={() => handleCloseMenu("Services")} disablePadding>
          <ListItemButton>
            <ListItemIcon>
              <HomeRoundedIcon fontSize="small" className="navListIcon" />
            </ListItemIcon>     
            <Typography className="navListText" >Home</Typography>
          </ListItemButton>
        </ListItem>
        {userInfo.userType =="Super Admin"|| userInfo.userType =="Admin"? (
        <ListItem key='Manage Users' onClick={() => handleCloseMenu("UserList")} disablePadding>
          <ListItemButton>
            <ListItemIcon>
              <PersonAdd fontSize="small" className="navListIcon" />
            </ListItemIcon>
            {/* <ListItemText primary='Manage Users' className="lstText" /> */}
            <Typography className="navListText" >Manage User</Typography>
          </ListItemButton>
        </ListItem>
        ): ""}
         {userInfo.userType =="Super Admin"|| userInfo.userType =="Admin"? (
        <ListItem key='Manage Roles' onClick={() => handleCloseMenu("RoleList")} disablePadding>
          <ListItemButton>
            <ListItemIcon>
              <DisplaySettingsIcon fontSize="small" className="navListIcon" />
            </ListItemIcon>
            {/* <ListItemText primary='Manage Roles' sx={{ color: '#151619' }} /> */}
            <Typography className="navListText" >Manage Roles</Typography>
          </ListItemButton>
        </ListItem>
           ): ""}
        {userInfo.userType == "Super Admin" ? (
          <ListItem key='Manage Services' onClick={() => handleCloseMenu("ServicesList")} disablePadding>
            <ListItemButton>
              <ListItemIcon>           
                <Settings fontSize="small" className="navListIcon" />
              </ListItemIcon>
              {/* <ListItemText primary=' Manage Services' sx={{ color: '#151619' }} /> */}
              <Typography className="navListText" >Manage Services</Typography>
            </ListItemButton>
          </ListItem>
        ) : ""}
       {   mdmAccessesInfo?.length > 0 ? (
        <Accordion className="expansion-panel" key='DMD'>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header">
            <ListItemIcon>
              <KeyboardArrowDownIcon  className="navListIcon" ></KeyboardArrowDownIcon>{" "}
            </ListItemIcon>
          
              {/*   <Typography > <ListItemText primary='Master Data' sx={{ color: '#151619' }} />   </Typography>*/}
              <Typography className="navListText" >Master Data</Typography>          
          </AccordionSummary>
          <AccordionDetails>
            {           
                mdmAccessesInfo.map((menu, index) => (
                  <ListItem key={menu.description} onClick={() => handleCloseMenu(menu.link)} disablePadding>
                    <ListItemButton>
                       <ListItemIcon>
                       <StorageTwoToneIcon fontSize="small" className="navListIcon" />
                      </ListItemIcon> 
                      {/* <ListItemText primary={menu.description} sx={{ color: '#151619' }} /> */}
                      <Typography className="navListText" >{menu.description}</Typography>       
                    </ListItemButton>
                  </ListItem>
                ))            
            }
          </AccordionDetails>
        </Accordion>
      ): ""}
      </List>
    </Box>
  );

  return (
    <div>
      {(['left'] as const).map((anchor) => (
        <React.Fragment key={anchor}>
          <IconButton
            aria-label="open drawer"
            edge="start"
            onClick={toggleDrawer(anchor, true)}
            sx={{ mr: 8, display: { sm: "block" } }}
            className="MDM-NAV"
          >
            {/* <SettingsIcon /> */}
            <MenuIcon /> 
          </IconButton>

          <SwipeableDrawer
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
            onOpen={toggleDrawer(anchor, true)}
          >
            {list(anchor)}
          </SwipeableDrawer>
        </React.Fragment>
      ))}
    </div>
  );
}
